<h2>Expiring Trips</h2>
<div class="filter-panel">
  <dx-select-box
    width="180px"
    height="30px"
    [dataSource]="pWeeksCol"
    displayExpr="name"
    valueExpr="value"
    [(value)]="pWeeks"
    (onValueChanged)="onWeeksChanged()"></dx-select-box>

  <dx-select-box
    width="180px"
    height="30px"
    [dataSource]="nWeeksCol"
    displayExpr="name"
    valueExpr="value"
    [(value)]="nWeeks"
    (onValueChanged)="onWeeksChanged()"></dx-select-box>
</div>

<dx-data-grid
  #grid
  class="content"
  [dataSource]="dso"
  [columns]="columns"
  [twoWayBindingEnabled]="false"
  (onInitialized)="grid_onInitialized($event)"
  (onToolbarPreparing)="grid_onToolbarPreparing($event)">
  <dxo-editing mode="none" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false"></dxo-editing>

  <dxo-paging [pageSize]="config.get('itemsPerPage', 50)"></dxo-paging>

  <dxo-export [enabled]="true" fileName="expiring-trips-export"></dxo-export>

  <!-- Templates -->
  <ng-container *dxTemplate="let cellInfo of 'trips'">
    <div [title]="getTripsTooltip(cellInfo)" style="cursor: pointer" [class]="getTripsClass(cellInfo)">
      {{ cellInfo.value }}
    </div>
  </ng-container>
</dx-data-grid>
